<div class="dashboard">

  <h1>
    Admin Panel
  </h1>

  <div class="cards">

    <a
      class="card"
      routerLink="/admin/products">

      Products

    </a>

    <a
      class="card"
      routerLink="/admin/categories">

      Categories

    </a>

  </div>

</div>